import {createApp} from 'vue';
import {createI18n} from "vue-i18n";
// @ts-ignore
import App from './App.vue'
import store from './store'
import numberFormats from "@km/data/numberFormats";
import axios from "axios";
import VueAxios from "vue-axios";
import {LanguageLoaderVue} from "@km/js/LanguageLoaderVue";
import {EnumDictionary, type StringDictionary} from "@k/js/delme_globals";
// @ts-ignore
import owayo_menu from "owayo_menu"
import "owayo_menu/dist/owayo_vue_menu.css"
import lazyLoadingDirective from "@km/js/lazyLoadingDirective";
import '../node_modules/vanilla-cookieconsent/src/cookieconsent.js'
import '@k/global/cookieconsent/cookieconsent_owayo.css'
import {setBUILD_ID} from "@k/global/globalUtils";
import {EventListener} from "@k/global/eventVerteiler";
import {CookieConsentHandler} from "@k/global/cookieconsent/cookieHandler";
import {initFacebookTracker} from "@k/global/tracking/initFacebookTracker";
import {createPinia} from "pinia";
import {StockLogoKopplungAnColorCodeHandler} from "@k/js/controllerModules/StockLogoKopplungAnColorCodeHandler";
import globalsObject from "@k/js/globalsObject";

const pinia = createPinia();

const app = createApp(App);
app.use(store);
app.use(VueAxios, axios);
app.use(owayo_menu);
app.use(pinia);
app.directive("lazyload", lazyLoadingDirective);

const languageIso = store.getters["ModelStore/getLanguageIso"];
const language = store.getters["ModelStore/getLanguage"];
const land = store.getters["ModelStore/getLand"];

const kundenKonfi = store.getters["ModelStore/getKundenKonfi"];

setBUILD_ID();

LanguageLoaderVue.loadLanguageTexts(languageIso, language, land, kundenKonfi).then((messages: EnumDictionary<string, string>) => {
    const withoutNulls = {};
    for (const key in messages) {
        if (messages[key] !== null) {
            withoutNulls[key] = messages[key].replace("{{", "[").replace("}}", "]");
        } else {
            withoutNulls[key] = key;
        }
    }

    const messagesObject = {};
    messagesObject[language] = withoutNulls;
    const i18n = createI18n({
        locale: languageIso,
        fallbackLocale: "de",
        legacy: false,
        numberFormats,
        messages: messagesObject,
        messageResolver:(messages:unknown, key:string) => (messages as StringDictionary<string>)[key.toLowerCase()] || null

    });

    app.use(i18n);
    app.mount('#appContainer');

});

new EventListener().addEventListener("CookieConsentChoiceMadeEvent", ()=>{
    if(CookieConsentHandler.analyticCookiesAllowed()) {
        initFacebookTracker();
    }
}).addEventListener("analyticCookiesAllowedEvent", ()=>{
    initFacebookTracker();
});

new StockLogoKopplungAnColorCodeHandler(
    () => globalsObject.controller.model.entwurf.getLogoObjects(),
    (id: string, colorCode: string, colorHexValue: string) => {
        globalsObject.controller.selObController.changeSelOb(id, {
                colors: {
                    colorCode: colorCode,
                    colorHexValue: colorHexValue
                }
            }
        )
    });